<template>
  <section class="submission-context" aria-label="Submission details">
    <article v-if="comment" class="context-card context-card-note">
      <span class="context-icon" aria-hidden="true">
        <b-icon-chat-left-text />
      </span>
      <div class="context-content">
        <span class="context-label">Supervisor note</span>
        <p class="context-value">{{ comment }}</p>
      </div>
    </article>

    <article class="context-card context-card-photos">
      <span class="context-icon" aria-hidden="true">
        <b-icon-camera />
      </span>
      <div class="context-content">
        <span class="context-label">Photos</span>
        <div v-if="photos.length" class="photo-list">
          <button
            v-for="(photo, index) in photos"
            :key="photo.id || photo.url || index"
            type="button"
            class="photo-button"
            :aria-label="'Open submission photo ' + (index + 1)"
            @click="$emit('open-lightbox', index)"
          >
            <img
              :src="photo.url"
              class="photo-thumbnail"
              :alt="'Submission photo ' + (index + 1)"
            />
          </button>
        </div>
        <span v-else class="context-empty">No photos attached</span>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'SupervisorSubmissionContext',
  props: {
    comment: { type: String, default: '' },
    photos: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
.submission-context {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 1fr);
  gap: 12px;
}

.context-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f8fafc;
}

.context-card-photos {
  min-width: 220px;
}

.context-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 14px;
}

.context-content {
  min-width: 0;
}

.context-label {
  display: block;
  margin-bottom: 4px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

.context-value {
  margin: 0;
  color: #374151;
  font-size: 13px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.context-empty {
  color: #9ca3af;
  font-size: 13px;
}

.photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.photo-button {
  display: inline-flex;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  box-shadow: 0 0 0 1px #e2e8f0;
  cursor: pointer;
  overflow: hidden;

  &:hover,
  &:focus-visible {
    box-shadow: 0 0 0 2px #6366f1;
    outline: none;
  }
}

.photo-thumbnail {
  display: block;
  width: 48px;
  height: 48px;
  object-fit: cover;
}

@media (max-width: 767.98px) {
  .submission-context {
    grid-template-columns: 1fr;
  }

  .context-card-photos {
    min-width: 0;
  }
}
</style>
